/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Platform_TitleInputs */

const en_mk_platform_title = /** @type {(inputs: Mk_Platform_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From plan to progress. One workspace.`)
};

const id_mk_platform_title = /** @type {(inputs: Mk_Platform_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rencana hingga hasil. Satu workspace.`)
};

/**
* | output |
* | --- |
* | "From plan to progress. One workspace." |
*
* @param {Mk_Platform_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_platform_title = /** @type {((inputs?: Mk_Platform_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Platform_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_platform_title(inputs)
	return en_mk_platform_title(inputs)
});